export enum OrderHoldStatus {
  Rejected = 'rejected',
  Quote = 'quote',
  Approved = 'approved',
  Pending = 'pending',
  Obsolete = 'obsolete',
}
